import React from 'react'
import { AdminPageWrapper, PageHeader, TCancelButton } from 'components'
import { useHistory, useLocation } from 'react-router-dom'
import FloorPlanData from 'components/FloorPlanData'

const CreateEditFloorPlan = () => {
  const location = useLocation()
  const history = useHistory()

  const {
    state: {
      _id
    }
  } = location

  const RightContent = () => (
    <TCancelButton
      onClick={() => history.goBack()}
    >
      Back
    </TCancelButton>
  )

  return (
    <>
      <PageHeader
        title={`${_id ? 'Editing' : 'Creating new'} floor plan`}
        rightContent={<RightContent />}
      />
      <AdminPageWrapper>
        <FloorPlanData
          _id={_id}
        />
      </AdminPageWrapper>
    </>
  )
}

export default CreateEditFloorPlan
